module.exports = __webpack_public_path__ + "img/16.bd0df0b8.jpg";